import React from 'react';
import withRouter from '../Common/withRouter';
const GetInTouch = (props) => {

    return (
        <div className='bg-black py-[20px] md:py-[15px] header-border-liner-gradient'>
            <div className='container'>
                <div className='block md:flex items-center gap-3 text-center md:text-left'>
                    <div className='flex-1'>
                        <p className='text-white text-sm font-normal'><span className='font-semibold text-lg'>List your show</span> — Whether it's a concert, workshop, or local event, get your event in front of the right audience by listing it on Mepass.</p>
                    </div>
                    <div className='flex-none mt-4 md:mt-0'>
                        <button onClick={() =>
                            window.open(`/business`, '_blank')
                        }
                            className='btn-liner-gradient text-white text-sm md:text-base text-center font-semibold py-[10px] px-4 md:px-8 rounded-lg font-body duration-1000 ease-in-out  md:h-[54px] flex items-center justify-center m-auto'>Join as a organiser</button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default withRouter(GetInTouch);
